module.exports = __webpack_public_path__ + "media/images/svgs/jobs/hourglass-white-b46ff1205d71aa247b1304b13cf424b2.svg";